<div class="nf-wrapper">
  <div class="nf-card">
    <div class="nf-logo">
      <img alt="Logo" src="/logo-login.svg"/>
    </div>
    <div class="nf-icon">
      <svg fill="none" height="48" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" x2="12" y1="8" y2="12"/>
        <line x1="12" x2="12.01" y1="16" y2="16"/>
      </svg>
    </div>
    <h2 class="nf-title">Invalid or Expired Link</h2>
    <p class="nf-subtitle">
      The verification link you followed is invalid or has already expired.
      Please request a new verification link.
    </p>
    <div class="nf-divider"></div>
    <p class="nf-help">
      If you believe this is a mistake, please contact support or request a new link from the platform.
    </p>
  </div>
</div>
